import { redirect, createFileRoute } from '@tanstack/react-router'
import { getPlayerSession } from '@/features/player-session'

export const Route = createFileRoute('/postal-request-code')({
  beforeLoad: async ({ location, search }) => {
    const playerSession = await getPlayerSession()

    if (playerSession.isUserLoggedIn) {
      search.amoe = 'postal-request-code'
      return redirect({ to: '/', search })
    }

    const targetUrl = window.location.origin + location.href

    await playerSession.login({
      redirectUrl: targetUrl,
      doesCurrentHrefRequiresAuth: window.location.href === targetUrl,
    })
  },
})
